import { render, staticRenderFns } from "./FaleConosco.vue?vue&type=template&id=88ef3876&scoped=true"
import script from "./FaleConosco.vue?vue&type=script&lang=js"
export * from "./FaleConosco.vue?vue&type=script&lang=js"
import style0 from "./FaleConosco.vue?vue&type=style&index=0&id=88ef3876&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88ef3876",
  null
  
)

export default component.exports